// extracted by mini-css-extract-plugin
export default {"quickStampTooltip":"ebEDhvAVWYFdUtAYDtSt","highlightQuickstamp":"n9DrIR60yF0bAIh3j0no","newTool":"x8AiUY8M4asG5sjBEPPh"};